import {createSelector} from "reselect";

const selectLimitsState = (state) => state.limits;

const selectLimits = () => createSelector(selectLimitsState, (limitsState) => limitsState.limits);
const selectFilter = () => createSelector(selectLimitsState, (limitsState) => limitsState.filter);

export {
    selectLimits,
    selectFilter
}